import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  fileExtension: {
    flex: "0 0 170px",
  },
  fileName: {
    wordBreak: "break-word",
    fontWeight: 500,
  },
  // `DataRow` sizes its action slot for exactly one icon button; the chip now
  // carries two (copy link + open), so let it grow instead of overflowing.
  fileActions: {
    width: "auto !important",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
  },
  fileRoot: {
    border: `1px solid ${theme.palette.separator.main}`,
    borderRadius: theme.spacing(1),
    background: theme.palette.attachmentsBackground.main,
    paddingLeft: theme.spacing(1.5),
    cursor: "pointer",
    "&:hover": {
      background: theme.palette.attachmentsBackground.main,
    },
  },
}));
